<script>
    import { onMount } from "svelte";
    import { NotificationModal } from "../../Components/Common/index.svelte";
    import { apiMethods } from "../../Services/index.svelte";
    import { showError, showInfo } from "../../Utils/utilFunctions.svelte";
    import ConfirmActionModal from "./ConfirmActionModal.svelte";

    export let isModalOpen = true,
        modalTitle,
        userId = null,
        encounterId = null,
        defaultTitle,
        defaultContent,
        userName,
        disableChanges = false,
        closeModal = () => {};

    let title, content;
    let isConfirm, isSending;

    onMount(() => {
        if(defaultTitle) title = defaultTitle;
        if(defaultContent) content = defaultContent;
    })

    const sendNotification = async () => {
        isSending = true;
        let notificationRequest = {
            userId: userId ?? 0,
            patientEncounterId: encounterId ?? 0,
            title,
            content
        }
        var sent = await apiMethods.postMethod.sendCustomNotification(notificationRequest);
        if(sent){
            showInfo("Notification was successfully sent.");
            closeModal();
        }
        else {
            showError("Notification was not sent. Please contact support.")
            isConfirm = false;
        }

    }

    const openSendNotificationConfirm = () => {
        isConfirm = true;
        console.log("show confirm");
    }
    
</script>

{#if isModalOpen}
    <NotificationModal
        {isModalOpen}
        title={modalTitle ?? "Send Push Notification"}
        cancelText="Close"
        submitText="Send"
        isConfirmDisabled={!title || !content}
        confirmAction={openSendNotificationConfirm}
        {closeModal}
        closeModalFunction={closeModal}
        modalMaxWidth="max-w-4xl"
    >
        <div class="flex flex-col gap-y-4 flex-1">
            {#if userName}
                <div class="flex flex-1 w-full gap-x-2 items-center">
                    <p class="title">User:</p>
                    <div class="content">
                        <input
                            type="text"
                            class="input flex-1 w-full input-sm input-bordered"
                            autocomplete="off"
                            disabled={true}
                            bind:value={userName}
                        />
                    </div>
                </div>
            {/if}
            <div class="flex flex-1 w-full gap-x-2 items-center">
                <p class="title">Title:</p>
                <div class="content">
                     <input
                        type="text"
                        class="input flex-1 w-full input-sm input-bordered"
                        autocomplete="off"
                        disabled={disableChanges}
                        bind:value={title}
                    />
                </div>
            </div>
            <div class="flex flex-1 w-full gap-x-2 items-center">
                <p class="title">Content:</p>
                <div class="content">
                    <textarea
                        class="textarea textarea-bordered w-full flex-1"
                        rows="3"
                        autocomplete="off"
                        disabled={disableChanges}
                        bind:value={content}
                    />
                </div>
            </div>
        </div>
    </NotificationModal>

    <ConfirmActionModal
        bind:isConfirmActionModalOpen={isConfirm}
        bind:isActionRunning={isSending}
        on:confirmAction={() => sendNotification()}
        title="Confirmation"
        confirmPrompt={`Please confirm you want to send this push notification to ${userName ?? "this user"}?`}
    />
{/if}

<style>
  .title {
    width: 150px;
  }
  .content {
    width: calc(100% - 150px);
  }
</style>